function Navbar() {
  return (
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <strong>Maia <i class="fa-solid fa-bolt" style={{color: "#e6b800"}}></i> Energia</strong>
        </a>

        <a href="/" role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <a href="/" className="button is-light">Sobre nós</a>
              <a href="/" className="button is-light">Contato</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
